export const IMPORT_TEXT = 'Import a new dataset';
export const ADD_DATASET = 'Import Dataset';
export const LIST_DATASETS = 'List Datasets';
export const SPARC_DATASETS = 'SPARC Datasets';
export const FILE_UPLOAD_PARAMS = {
  acceptedFileExtensions: ['json', 'ttl'],
  maxFileSize: 202428800000,
  maxFiles: 6,
};
export const NODES = ["dataset", "nifti", "volume", "matlab"];

export const detailsLabel = "_details";

export const subject_key = "all_subjects";
export const performances_key = "all_performances";
export const protocols_key = "all_protocols";
export const contributors_key = "all_contributors";

export const GRAPH_SOURCE = "GRAPH";
export const TREE_SOURCE = "TREE";
export const SUBJECTS_LEVEL = 2;
export const PROTOCOLS_LEVEL = 2;
export const CRONTRIBUTORS_LEVEL = 2;